// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"78a73f45","444":"0275f8ff","845":"0b6c102a"}[chunkId] + ".chunk.js";
};